/** @jsxImportSource @emotion/react */

import type { ChangeEventHandler } from "react";
import { Flex } from "../utilities";
import { checkboxIconCSS } from "./Checkbox.css";
import type { CheckboxIconProps, CheckboxProps } from "./Checkbox.types";

export const CheckboxIcon = ({ isIndeterminate }: CheckboxIconProps) => {
  const path = isIndeterminate ? "M2.5 6H9.5" : "M9.5 3L4.6875 8.5L2.5 6";

  return (
    <span className="clay-checkbox-wrapper" css={checkboxIconCSS}>
      <svg
        className="clay-checkbox-icon"
        width="100%"
        height="100%"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d={path}
          stroke='currentColor'
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
};

export const Checkbox = ({
  isIndeterminate,
  onChange,
  onChangeChecked,
  ...restProps
}: CheckboxProps) => {
  const _onChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    onChange?.(e);
    onChangeChecked?.(e.target.checked);
  };

  return (
    <Flex display="inline-flex" as="label" native={{ htmlFor: restProps.id }}>
      <input type="checkbox" data-clay-blind onChange={_onChange} {...restProps} />
      <CheckboxIcon isIndeterminate={isIndeterminate} />
    </Flex>
  );
};
